import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=05d7fef0&scoped=true&"
import script from "./AllUsers.vue?vue&type=script&lang=js&"
export * from "./AllUsers.vue?vue&type=script&lang=js&"
import style0 from "./AllUsers.vue?vue&type=style&index=0&id=05d7fef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7fef0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VChip,VContainer,VDataTable,VFlex,VLayout,VPagination})
